<span *ngIf="alarmState === 'OK'" class="badge badge-ok">OK ✔</span>
<span *ngIf="alarmState === 'ALARM'" class="badge badge-alarm">ALARM 🔥</span>
<span *ngIf="alarmState === 'INSUFFICIENT_DATA'" class="badge badge-pending">PENDING ⏳</span>